import CesAbundanceEnum, { CesAbundance } from "./CesAbundanceEnum.generated";
import CesAquaticInvasivePlantEnum, {
  CesAquaticInvasivePlant,
} from "./CesAquaticInvasivePlantEnum.generated";
import CesAquaticVegetationFormEnum, {
  CesAquaticVegetationForm,
} from "./CesAquaticVegetationFormEnum.generated";
import CesBankFeatureEnum, {
  CesBankFeature,
} from "./CesBankFeatureEnum.generated";
import CesBankHorizontalProfileEnum, {
  CesBankHorizontalProfile,
} from "./CesBankHorizontalProfileEnum.generated";
import CesBankTerrestrialVegetationEnum, {
  CesBankTerrestrialVegetation,
} from "./CesBankTerrestrialVegetationEnum.generated";
import CesBankTopMaterialEnum, {
  CesBankTopMaterial,
} from "./CesBankTopMaterialEnum.generated";
import CesBankTopTerrestrialVegetationEnum, {
  CesBankTopTerrestrialVegetation,
} from "./CesBankTopTerrestrialVegetationEnum.generated";
import CesBankTopTreeFeatureEnum, {
  CesBankTopTreeFeature,
} from "./CesBankTopTreeFeatureEnum.generated";
import CesBankTopVegetationManagementEnum, {
  CesBankTopVegetationManagement,
} from "./CesBankTopVegetationManagementEnum.generated";
import CesBankTopVegetationStructureEnum, {
  CesBankTopVegetationStructure,
} from "./CesBankTopVegetationStructureEnum.generated";
import CesBankTreeFeatureEnum, {
  CesBankTreeFeature,
} from "./CesBankTreeFeatureEnum.generated";
import CesBankVerticalProfileEnum, {
  CesBankVerticalProfile,
} from "./CesBankVerticalProfileEnum.generated";
import CesConditionEnum, { CesCondition } from "./CesConditionEnum.generated";
import CesContinuityEnum, {
  CesContinuity,
} from "./CesContinuityEnum.generated";
import CesDominanceEnum, { CesDominance } from "./CesDominanceEnum.generated";
import CesFringeContinuityEnum, {
  CesFringeContinuity,
} from "./CesFringeContinuityEnum.generated";
import CesFringeWidthEnum, {
  CesFringeWidth,
} from "./CesFringeWidthEnum.generated";
import CesJettyAlignmentEnum, {
  CesJettyAlignment,
} from "./CesJettyAlignmentEnum.generated";
import CesJettySizeEnum, { CesJettySize } from "./CesJettySizeEnum.generated";
import CesLandCoverCategoryEnum, {
  CesLandCoverCategory,
} from "./CesLandCoverCategoryEnum.generated";
import CesLandCoverTypeEnum, {
  CesLandCoverType,
} from "./CesLandCoverTypeEnum.generated";
import CesNaturalMaterialEnum, {
  CesNaturalMaterial,
} from "./CesNaturalMaterialEnum.generated";
import CesPathWidthEnum, { CesPathWidth } from "./CesPathWidthEnum.generated";
import CesReinforcementExtentEnum, {
  CesReinforcementExtent,
} from "./CesReinforcementExtentEnum.generated";
import CesReinforcementMaterialEnum, {
  CesReinforcementMaterial,
} from "./CesReinforcementMaterialEnum.generated";
import CesSurveyedFromEnum, {
  CesSurveyedFrom,
} from "./CesSurveyedFromEnum.generated";
import CesTerrestrialInvasivePlantEnum, {
  CesTerrestrialInvasivePlant,
} from "./CesTerrestrialInvasivePlantEnum.generated";
import CesTypicalHedgeWidthEnum, {
  CesTypicalHedgeWidth,
} from "./CesTypicalHedgeWidthEnum.generated";
import CesWaterFeatureConditionEnum, {
  CesWaterFeatureCondition,
} from "./CesWaterFeatureConditionEnum.generated";
import CesWoodySpeciesCountEnum, {
  CesWoodySpeciesCount,
} from "./CesWoodySpeciesCountEnum.generated";
import EcostatusAbsentMinorMajorEnum, {
  EcostatusAbsentMinorMajor,
} from "./EcostatusAbsentMinorMajorEnum.generated";
import EcostatusConditionAndUseEnum, {
  EcostatusConditionAndUse,
} from "./EcostatusConditionAndUseEnum.generated";
import EcostatusConfidenceLevelEnum, {
  EcostatusConfidenceLevel,
} from "./EcostatusConfidenceLevelEnum.generated";
import EcostatusConnectivityEnum, {
  EcostatusConnectivity,
} from "./EcostatusConnectivityEnum.generated";
import EcostatusHygieneEnum, {
  EcostatusHygiene,
} from "./EcostatusHygieneEnum.generated";
import EcostatusLitterEnum, {
  EcostatusLitter,
} from "./EcostatusLitterEnum.generated";
import EcostatusLitterDisposalEnum, {
  EcostatusLitterDisposal,
} from "./EcostatusLitterDisposalEnum.generated";
import EcostatusNfmCategoryEnum, {
  EcostatusNfmCategory,
} from "./EcostatusNfmCategoryEnum.generated";
import EcostatusNfmPositionEnum, {
  EcostatusNfmPosition,
} from "./EcostatusNfmPositionEnum.generated";
import EcostatusNoneOneMoreEnum, {
  EcostatusNoneOneMore,
} from "./EcostatusNoneOneMoreEnum.generated";
import EcostatusNoneSomeManyEnum, {
  EcostatusNoneSomeMany,
} from "./EcostatusNoneSomeManyEnum.generated";
import EcostatusPersonalSafetyEnum, {
  EcostatusPersonalSafety,
} from "./EcostatusPersonalSafetyEnum.generated";
import EcostatusPollutionTypeEnum, {
  EcostatusPollutionType,
} from "./EcostatusPollutionTypeEnum.generated";
import EcostatusPoorModerateGoodEnum, {
  EcostatusPoorModerateGood,
} from "./EcostatusPoorModerateGoodEnum.generated";
import EcostatusRailAccessEnum, {
  EcostatusRailAccess,
} from "./EcostatusRailAccessEnum.generated";
import EcostatusRecreationalFacilityEnum, {
  EcostatusRecreationalFacility,
} from "./EcostatusRecreationalFacilityEnum.generated";
import EcostatusStudyAreaAccessProvisionEnum, {
  EcostatusStudyAreaAccessProvision,
} from "./EcostatusStudyAreaAccessProvisionEnum.generated";
import EcostatusStudyAreaAccessRestrictionEnum, {
  EcostatusStudyAreaAccessRestriction,
} from "./EcostatusStudyAreaAccessRestrictionEnum.generated";
import EcostatusStudyAreaBankEnum, {
  EcostatusStudyAreaBank,
} from "./EcostatusStudyAreaBankEnum.generated";
import EcostatusStudyAreaOwnershipEnum, {
  EcostatusStudyAreaOwnership,
} from "./EcostatusStudyAreaOwnershipEnum.generated";
import ExtendedRiverflySpeciesEnum, {
  ExtendedRiverflySpecies,
} from "./ExtendedRiverflySpeciesEnum.generated";
import MrsArtificialGroundCoverEnum, {
  MrsArtificialGroundCover,
} from "./MrsArtificialGroundCoverEnum.generated";
import MrsAtpeEnum, { MrsAtpe } from "./MrsAtpeEnum.generated";
import MrsBankProfileEnum, {
  MrsBankProfile,
} from "./MrsBankProfileEnum.generated";
import MrsBedMaterialParticleSizeEnum, {
  MrsBedMaterialParticleSize,
} from "./MrsBedMaterialParticleSizeEnum.generated";
import MrsChannelCoverageEnum, {
  MrsChannelCoverage,
} from "./MrsChannelCoverageEnum.generated";
import MrsMorphEstuariesDaysToSpringTideEnum, {
  MrsMorphEstuariesDaysToSpringTide,
} from "./MrsMorphEstuariesDaysToSpringTideEnum.generated";
import MrsMorphEstuariesVisibilityEnum, {
  MrsMorphEstuariesVisibility,
} from "./MrsMorphEstuariesVisibilityEnum.generated";
import MrsMorphEstuariesFloodWallDimensionEnum, {
  MrsMorphEstuariesFloodWallDimension,
} from "./MrsMorphEstuariesFloodWallDimensionEnum.generated";
import MrsMorphEstuariesSmallFragmentDistributionEnum, {
  MrsMorphEstuariesSmallFragmentDistribution,
} from "./MrsMorphEstuariesSmallFragmentDistributionEnum.generated";
import MrsMorphEstuariesMarginTypeEnum, {
  MrsMorphEstuariesMarginType,
} from "./MrsMorphEstuariesMarginTypeEnum.generated";
import MrsMorphEstuariesDrainageNetworkTypeEnum, {
  MrsMorphEstuariesDrainageNetworkType,
} from "./MrsMorphEstuariesDrainageNetworkTypeEnum.generated";
import MrsMorphEstuariesCreekTypeEnum, {
  MrsMorphEstuariesCreekType,
} from "./MrsMorphEstuariesCreekTypeEnum.generated";
import MrsMorphEstuariesSaltMarshLocationEnum, {
  MrsMorphEstuariesSaltMarshLocation,
} from "./MrsMorphEstuariesSaltMarshLocationEnum.generated";
import MrsMorphEstuariesFragmentationEnum, {
  MrsMorphEstuariesFragmentation,
} from "./MrsMorphEstuariesFragmentationEnum.generated";
import MrsMorphEstuariesFrontBackCreekMarginEnum, {
  MrsMorphEstuariesFrontBackCreekMargin,
} from "./MrsMorphEstuariesFrontBackCreekMarginEnum.generated";
import MrsMorphEstuariesGrazingEnum, {
  MrsMorphEstuariesGrazing,
} from "./MrsMorphEstuariesGrazingEnum.generated";
import MrsMorphEstuariesVegetatedIntertidalSedimentSizeEnum, {
  MrsMorphEstuariesVegetatedIntertidalSedimentSize,
} from "./MrsMorphEstuariesVegetatedIntertidalSedimentSizeEnum.generated";
import MrsMorphEstuariesSubtidalSedimentSizeEnum, {
  MrsMorphEstuariesSubtidalSedimentSize,
} from "./MrsMorphEstuariesSubtidalSedimentSizeEnum.generated";
import MrsMorphEstuariesTidalFloodBarrierEnum, {
  MrsMorphEstuariesTidalFloodBarrier,
} from "./MrsMorphEstuariesTidalFloodBarrierEnum.generated";
import MrsFlowTypeEnum, { MrsFlowType } from "./MrsFlowTypeEnum.generated";
import MrsMajorIntermediateMinorEnum, {
  MrsMajorIntermediateMinor,
} from "./MrsMajorIntermediateMinorEnum.generated";
import MrsReinforcementTypeEnum, {
  MrsReinforcementType,
} from "./MrsReinforcementTypeEnum.generated";
import MrsReinforcementVerticalExtentEnum, {
  MrsReinforcementVerticalExtent,
} from "./MrsReinforcementVerticalExtentEnum.generated";
import MrsRtaAverageBedMaterialEnum, {
  MrsRtaAverageBedMaterial,
} from "./MrsRtaAverageBedMaterialEnum.generated";
import MrsRtaCoarsestBedMaterialEnum, {
  MrsRtaCoarsestBedMaterial,
} from "./MrsRtaCoarsestBedMaterialEnum.generated";
import MrsRtaConditionClassEnum, {
  MrsRtaConditionClass,
} from "./MrsRtaConditionClassEnum.generated";
import MrsRtaLevelOfConfinementEnum, {
  MrsRtaLevelOfConfinement,
} from "./MrsRtaLevelOfConfinementEnum.generated";
import MrsRtaRiverCategoryEnum, {
  MrsRtaRiverCategory,
} from "./MrsRtaRiverCategoryEnum.generated";
import MrsRtaRiverTypeEnum, {
  MrsRtaRiverType,
} from "./MrsRtaRiverTypeEnum.generated";
import MrsSedimentSizeEnum, {
  MrsSedimentSize,
} from "./MrsSedimentSizeEnum.generated";
import MrsMudSpotterRainfallIntensityEnum, {
  MrsMudSpotterRainfallIntensity,
} from "./MrsMudSpotterRainfallIntensityEnum.generated";
import MrsMudSpotterSourceTypeEnum, {
  MrsMudSpotterSourceType,
} from "./MrsMudSpotterSourceTypeEnum.generated";
import MrsMudSpotterSourceSubTypeEnum, {
  MrsMudSpotterSourceSubType,
} from "./MrsMudSpotterSourceSubTypeEnum.generated";
import MrsMudSpotterSourceSizeEnum, {
  MrsMudSpotterSourceSize,
} from "./MrsMudSpotterSourceSizeEnum.generated";
import MrsMudSpotterFlowEnum, {
  MrsMudSpotterFlow,
} from "./MrsMudSpotterFlowEnum.generated";
import MrsMudSpotterSedimentEnum, {
  MrsMudSpotterSediment,
} from "./MrsMudSpotterSedimentEnum.generated";
import MrsTreeTypeEnum, { MrsTreeType } from "./MrsTreeTypeEnum.generated";
import NeChalkRiversFeatureEnum, {
  NeChalkRiversFeature,
} from "./NeChalkRiversFeatureEnum.generated";
import NeChalkRiversModificationTypeEnum, {
  NeChalkRiversModificationType,
} from "./NeChalkRiversModificationTypeEnum.generated";
import NeChalkRiversPhEnum, {
  NeChalkRiversPh,
} from "./NeChalkRiversPhEnum.generated";
import NeChalkRiversTreeShadingEnum, {
  NeChalkRiversTreeShading,
} from "./NeChalkRiversTreeShadingEnum.generated";
import NeLakeNaturalnessBirdSpeciesEnum, {
  NeLakeNaturalnessBirdSpecies,
} from "./NeLakeNaturalnessBirdSpeciesEnum.generated";
import NeLakeNaturalnessChemicalAssessmentFormEnum, {
  NeLakeNaturalnessChemicalAssessmentForm,
} from "./NeLakeNaturalnessChemicalAssessmentFormEnum.generated";
import NeLakeNaturalnessEmergentFringeEnum, {
  NeLakeNaturalnessEmergentFringe,
} from "./NeLakeNaturalnessEmergentFringeEnum.generated";
import NeLakeNaturalnessFishSpeciesEnum, {
  NeLakeNaturalnessFishSpecies,
} from "./NeLakeNaturalnessFishSpeciesEnum.generated";
import NeLakeNaturalnessHerpetofaunaSpeciesEnum, {
  NeLakeNaturalnessHerpetofaunaSpecies,
} from "./NeLakeNaturalnessHerpetofaunaSpeciesEnum.generated";
import NeLakeNaturalnessHigherPlantSpeciesEnum, {
  NeLakeNaturalnessHigherPlantSpecies,
} from "./NeLakeNaturalnessHigherPlantSpeciesEnum.generated";
import NeLakeNaturalnessInvertebrateSpeciesEnum, {
  NeLakeNaturalnessInvertebrateSpecies,
} from "./NeLakeNaturalnessInvertebrateSpeciesEnum.generated";
import NeLakeNaturalnessMammalSpeciesEnum, {
  NeLakeNaturalnessMammalSpecies,
} from "./NeLakeNaturalnessMammalSpeciesEnum.generated";
import NeLakeNaturalnessOutflowStructureEnum, {
  NeLakeNaturalnessOutflowStructure,
} from "./NeLakeNaturalnessOutflowStructureEnum.generated";
import NeLakeNaturalnessPerimeterTreesEnum, {
  NeLakeNaturalnessPerimeterTrees,
} from "./NeLakeNaturalnessPerimeterTreesEnum.generated";
import NeLakeNaturalnessPlantFunctionalGroupEnum, {
  NeLakeNaturalnessPlantFunctionalGroup,
} from "./NeLakeNaturalnessPlantFunctionalGroupEnum.generated";
import NeLakeNaturalnessRiparianZoneEnum, {
  NeLakeNaturalnessRiparianZone,
} from "./NeLakeNaturalnessRiparianZoneEnum.generated";
import NeLakeNaturalnessShorelineModificationEnum, {
  NeLakeNaturalnessShorelineModification,
} from "./NeLakeNaturalnessShorelineModificationEnum.generated";
import NeLakeRestorationPrioritiesBiologicalMeasureEnum, {
  NeLakeRestorationPrioritiesBiologicalMeasure,
} from "./NeLakeRestorationPrioritiesBiologicalMeasureEnum.generated";
import NeLakeRestorationPrioritiesChemicalMeasureEnum, {
  NeLakeRestorationPrioritiesChemicalMeasure,
} from "./NeLakeRestorationPrioritiesChemicalMeasureEnum.generated";
import NeLakeRestorationPrioritiesHydrologicalMeasureEnum, {
  NeLakeRestorationPrioritiesHydrologicalMeasure,
} from "./NeLakeRestorationPrioritiesHydrologicalMeasureEnum.generated";
import NeLakeRestorationPrioritiesPhysicalMeasureEnum, {
  NeLakeRestorationPrioritiesPhysicalMeasure,
} from "./NeLakeRestorationPrioritiesPhysicalMeasureEnum.generated";
import NeNameSourceEnum, { NeNameSource } from "./NeNameSourceEnum.generated";
import NeNaturalnessClassEnum, {
  NeNaturalnessClass,
} from "./NeNaturalnessClassEnum.generated";
import NeNaturalnessConfidenceClassEnum, {
  NeNaturalnessConfidenceClass,
} from "./NeNaturalnessConfidenceClassEnum.generated";
import NeRestorationRelevanceEnum, {
  NeRestorationRelevance,
} from "./NeRestorationRelevanceEnum.generated";
import NeRiverNaturalnessBiologicalAssessmentFormEnum, {
  NeRiverNaturalnessBiologicalAssessmentForm,
} from "./NeRiverNaturalnessBiologicalAssessmentFormEnum.generated";
import NeRiverNaturalnessBirdSpeciesEnum, {
  NeRiverNaturalnessBirdSpecies,
} from "./NeRiverNaturalnessBirdSpeciesEnum.generated";
import NeRiverNaturalnessBryophyteSpeciesEnum, {
  NeRiverNaturalnessBryophyteSpecies,
} from "./NeRiverNaturalnessBryophyteSpeciesEnum.generated";
import NeRiverNaturalnessChemicalAssessmentFormEnum, {
  NeRiverNaturalnessChemicalAssessmentForm,
} from "./NeRiverNaturalnessChemicalAssessmentFormEnum.generated";
import NeRiverNaturalnessFeatureEnum, {
  NeRiverNaturalnessFeature,
} from "./NeRiverNaturalnessFeatureEnum.generated";
import NeRiverNaturalnessFernSpeciesEnum, {
  NeRiverNaturalnessFernSpecies,
} from "./NeRiverNaturalnessFernSpeciesEnum.generated";
import NeRiverNaturalnessFishSpeciesEnum, {
  NeRiverNaturalnessFishSpecies,
} from "./NeRiverNaturalnessFishSpeciesEnum.generated";
import NeRiverNaturalnessHerpetofaunaSpeciesEnum, {
  NeRiverNaturalnessHerpetofaunaSpecies,
} from "./NeRiverNaturalnessHerpetofaunaSpeciesEnum.generated";
import NeRiverNaturalnessHigherPlantSpeciesEnum, {
  NeRiverNaturalnessHigherPlantSpecies,
} from "./NeRiverNaturalnessHigherPlantSpeciesEnum.generated";
import NeRiverNaturalnessHydrologicalAssessmentFormEnum, {
  NeRiverNaturalnessHydrologicalAssessmentForm,
} from "./NeRiverNaturalnessHydrologicalAssessmentFormEnum.generated";
import NeRiverNaturalnessInvertebrateSpeciesEnum, {
  NeRiverNaturalnessInvertebrateSpecies,
} from "./NeRiverNaturalnessInvertebrateSpeciesEnum.generated";
import NeRiverNaturalnessMammalSpeciesEnum, {
  NeRiverNaturalnessMammalSpecies,
} from "./NeRiverNaturalnessMammalSpeciesEnum.generated";
import NeRiverNaturalnessPhysicalAssessmentFormEnum, {
  NeRiverNaturalnessPhysicalAssessmentForm,
} from "./NeRiverNaturalnessPhysicalAssessmentFormEnum.generated";
import NeRiverRestorationPrioritiesBiologicalMeasureEnum, {
  NeRiverRestorationPrioritiesBiologicalMeasure,
} from "./NeRiverRestorationPrioritiesBiologicalMeasureEnum.generated";
import NeRiverRestorationPrioritiesChemicalMeasureEnum, {
  NeRiverRestorationPrioritiesChemicalMeasure,
} from "./NeRiverRestorationPrioritiesChemicalMeasureEnum.generated";
import NeRiverRestorationPrioritiesHydrologicalMeasureEnum, {
  NeRiverRestorationPrioritiesHydrologicalMeasure,
} from "./NeRiverRestorationPrioritiesHydrologicalMeasureEnum.generated";
import NeRiverRestorationPrioritiesPhysicalMeasureEnum, {
  NeRiverRestorationPrioritiesPhysicalMeasure,
} from "./NeRiverRestorationPrioritiesPhysicalMeasureEnum.generated";
import NeYesNoUncertainEnum, {
  NeYesNoUncertain,
} from "./NeYesNoUncertainEnum.generated";
import NwcSeedbankCollectionEnum, {
  NwcSeedbankCollection,
} from "./NwcSeedbankCollectionEnum.generated";
import NwcSeedbankPermissionEnum, {
  NwcSeedbankPermission,
} from "./NwcSeedbankPermissionEnum.generated";
import NwcSeedbankSpeciesEnum, {
  NwcSeedbankSpecies,
} from "./NwcSeedbankSpeciesEnum.generated";
import NwcSeedbankAreaEnum, {
  NwcSeedbankArea,
} from "./NwcSeedbankAreaEnum.generated";
import NwcSeedbankLandUseEnum, {
  NwcSeedbankLandUse,
} from "./NwcSeedbankLandUseEnum.generated";
import NwcSeedbankVegetationEnum, {
  NwcSeedbankVegetation,
} from "./NwcSeedbankVegetationEnum.generated";
import NwcSeedbankSoilTypeEnum, {
  NwcSeedbankSoilType,
} from "./NwcSeedbankSoilTypeEnum.generated";
import NwcSeedbankProblemPlantSpeciesEnum, {
  NwcSeedbankProblemPlantSpecies,
} from "./NwcSeedbankProblemPlantSpeciesEnum.generated";
import NwcSeedbankEvidenceOfPollutionEnum, {
  NwcSeedbankEvidenceOfPollution,
} from "./NwcSeedbankEvidenceOfPollutionEnum.generated";
import RiverflySpeciesEnum, {
  RiverflySpecies,
} from "./RiverflySpeciesEnum.generated";
import StdActivityTypeEnum, {
  StdActivityType,
} from "./StdActivityTypeEnum.generated";
import StdInvasiveSpeciesEnum, {
  StdInvasiveSpecies,
} from "./StdInvasiveSpeciesEnum.generated";
import StdInvasiveSpeciesAmountEnum, {
  StdInvasiveSpeciesAmount,
} from "./StdInvasiveSpeciesAmountEnum.generated";
import StdInvasiveSpeciesTreatmentEnum, {
  StdInvasiveSpeciesTreatment,
} from "./StdInvasiveSpeciesTreatmentEnum.generated";
import StormPhosphatesLevelEnum, {
  StormPhosphatesLevel,
} from "./StormPhosphatesLevelEnum.generated";
import StormPhosphatesLevelTrendEnum, {
  StormPhosphatesLevelTrend,
} from "./StormPhosphatesLevelTrendEnum.generated";
import Thames21BadgedGroupEventActivityEnum, {
  Thames21BadgedGroupEventActivity,
} from "./Thames21BadgedGroupEventActivityEnum.generated";
import Thames21BadgedGroupEventLargeRubbishEnum, {
  Thames21BadgedGroupEventLargeRubbish,
} from "./Thames21BadgedGroupEventLargeRubbishEnum.generated";
import Thames21BadgedGroupEventSettingEnum, {
  Thames21BadgedGroupEventSetting,
} from "./Thames21BadgedGroupEventSettingEnum.generated";
import Thames21ChannelSideEnum, {
  Thames21ChannelSide,
} from "./Thames21ChannelSideEnum.generated";
import Thames21ForeshoreEnum, {
  Thames21Foreshore,
} from "./Thames21ForeshoreEnum.generated";
import Thames21InnsAccessibleByEnum, {
  Thames21InnsAccessibleBy,
} from "./Thames21InnsAccessibleByEnum.generated";
import Thames21InnsSpeciesEnum, {
  Thames21InnsSpecies,
} from "./Thames21InnsSpeciesEnum.generated";
import Thames21InnsGrowthStageEnum, {
  Thames21InnsGrowthStage,
} from "./Thames21InnsGrowthStageEnum.generated";
import Thames21InnsCoverageEnum, {
  Thames21InnsCoverage,
} from "./Thames21InnsCoverageEnum.generated";
import Thames21InnsProximityEnum, {
  Thames21InnsProximity,
} from "./Thames21InnsProximityEnum.generated";
import Thames21InnsManagementEnum, {
  Thames21InnsManagement,
} from "./Thames21InnsManagementEnum.generated";
import Thames21LitterCategoryEnum, {
  Thames21LitterCategory,
} from "./Thames21LitterCategoryEnum.generated";
import Thames21LitterCleanupFocusEnum, {
  Thames21LitterCleanupFocus,
} from "./Thames21LitterCleanupFocusEnum.generated";
import Thames21LitterItemEnum, {
  Thames21LitterItem,
} from "./Thames21LitterItemEnum.generated";
import Thames21LitterMetricEnum, {
  Thames21LitterMetric,
} from "./Thames21LitterMetricEnum.generated";
import Thames21LitterPolystyreneCoverEnum, {
  Thames21LitterPolystyreneCover,
} from "./Thames21LitterPolystyreneCoverEnum.generated";
import Thames21LitterSmallPlasticCountEnum, {
  Thames21LitterSmallPlasticCount,
} from "./Thames21LitterSmallPlasticCountEnum.generated";
import Thames21LitterSurveyTypeEnum, {
  Thames21LitterSurveyType,
} from "./Thames21LitterSurveyTypeEnum.generated";
import Thames21RapidAppraisalBeachGradeEnum, {
  Thames21RapidAppraisalBeachGrade,
} from "./Thames21RapidAppraisalBeachGradeEnum.generated";
import Thames21RapidAppraisalImmobileItemEnum, {
  Thames21RapidAppraisalImmobileItem,
} from "./Thames21RapidAppraisalImmobileItemEnum.generated";
import Thames21RiverEnum, {
  Thames21River,
} from "./Thames21RiverEnum.generated";
import Thames21SlowFlowFeatureTypeEnum, {
  Thames21SlowFlowFeatureType,
} from "./Thames21SlowFlowFeatureTypeEnum.generated";
import Thames21SlowFlowPondTypeEnum, {
  Thames21SlowFlowPondType,
} from "./Thames21SlowFlowPondTypeEnum.generated";
import Thames21SlowFlowServiceTypeEnum, {
  Thames21SlowFlowServiceType,
} from "./Thames21SlowFlowServiceTypeEnum.generated";
import Thames21SlowFlowSiteEnum, {
  Thames21SlowFlowSite,
} from "./Thames21SlowFlowSiteEnum.generated";
import Thames21SlowFlowSuitabilityEnum, {
  Thames21SlowFlowSuitability,
} from "./Thames21SlowFlowSuitabilityEnum.generated";
import Thames21SlowFlowSurveyTypeEnum, {
  Thames21SlowFlowSurveyType,
} from "./Thames21SlowFlowSurveyTypeEnum.generated";
import Thames21SlowFlowVegetationTypeEnum, {
  Thames21SlowFlowVegetationType,
} from "./Thames21SlowFlowVegetationTypeEnum.generated";
import Thames21VegetationOriginEnum, {
  Thames21VegetationOrigin,
} from "./Thames21VegetationOriginEnum.generated";
import Thames21VegetationSiteEnum, {
  Thames21VegetationSite,
} from "./Thames21VegetationSiteEnum.generated";
import Thames21VegetationStructureEnum, {
  Thames21VegetationStructure,
} from "./Thames21VegetationStructureEnum.generated";
import Thames21VegetationTypeEnum, {
  Thames21VegetationType,
} from "./Thames21VegetationTypeEnum.generated";
import UrbanRiverflySpeciesEnum, {
  UrbanRiverflySpecies,
} from "./UrbanRiverflySpeciesEnum.generated";
import UrsApeEnum, { UrsApe } from "./UrsApeEnum.generated";
import UrsArtificialBankProfileEnum, {
  UrsArtificialBankProfile,
} from "./UrsArtificialBankProfileEnum.generated";
import UrsArtificialBankReinforcementEnum, {
  UrsArtificialBankReinforcement,
} from "./UrsArtificialBankReinforcementEnum.generated";
import UrsArtificialFeatureEnum, {
  UrsArtificialFeature,
} from "./UrsArtificialFeatureEnum.generated";
import UrsArtificialFeatureCategoryEnum, {
  UrsArtificialFeatureCategory,
} from "./UrsArtificialFeatureCategoryEnum.generated";
import UrsBankMaterialEnum, {
  UrsBankMaterial,
} from "./UrsBankMaterialEnum.generated";
import UrsBankProtectionEnum, {
  UrsBankProtection,
} from "./UrsBankProtectionEnum.generated";
import UrsBankStructureEnum, {
  UrsBankStructure,
} from "./UrsBankStructureEnum.generated";
import UrsBridgeTypeEnum, {
  UrsBridgeType,
} from "./UrsBridgeTypeEnum.generated";
import UrsChannelDynamicsCategoryEnum, {
  UrsChannelDynamicsCategory,
} from "./UrsChannelDynamicsCategoryEnum.generated";
import UrsChannelDynamicsExtentEnum, {
  UrsChannelDynamicsExtent,
} from "./UrsChannelDynamicsExtentEnum.generated";
import UrsChannelDynamicsFeatureEnum, {
  UrsChannelDynamicsFeature,
} from "./UrsChannelDynamicsFeatureEnum.generated";
import UrsChannelFeatureEnum, {
  UrsChannelFeature,
} from "./UrsChannelFeatureEnum.generated";
import UrsChannelSubstrateEnum, {
  UrsChannelSubstrate,
} from "./UrsChannelSubstrateEnum.generated";
import UrsCountedHabitatFeatureEnum, {
  UrsCountedHabitatFeature,
} from "./UrsCountedHabitatFeatureEnum.generated";
import UrsCrossProfileEnum, {
  UrsCrossProfile,
} from "./UrsCrossProfileEnum.generated";
import UrsEcologicalCategoryEnum, {
  UrsEcologicalCategory,
} from "./UrsEcologicalCategoryEnum.generated";
import UrsEcologicalCharacteristicEnum, {
  UrsEcologicalCharacteristic,
} from "./UrsEcologicalCharacteristicEnum.generated";
import UrsFlowTypeEnum, { UrsFlowType } from "./UrsFlowTypeEnum.generated";
import UrsLandUseEnum, { UrsLandUse } from "./UrsLandUseEnum.generated";
import UrsManagementFeatureEnum, {
  UrsManagementFeature,
} from "./UrsManagementFeatureEnum.generated";
import UrsMarginalFeatureEnum, {
  UrsMarginalFeature,
} from "./UrsMarginalFeatureEnum.generated";
import UrsNaturalBankProfileEnum, {
  UrsNaturalBankProfile,
} from "./UrsNaturalBankProfileEnum.generated";
import UrsNuisanceSpeciesEnum, {
  UrsNuisanceSpecies,
} from "./UrsNuisanceSpeciesEnum.generated";
import UrsPercentageHabitatFeatureEnum, {
  UrsPercentageHabitatFeature,
} from "./UrsPercentageHabitatFeatureEnum.generated";
import UrsPlanformEnum, { UrsPlanform } from "./UrsPlanformEnum.generated";
import UrsPollutionIndicatorEnum, {
  UrsPollutionIndicator,
} from "./UrsPollutionIndicatorEnum.generated";
import UrsPollutionSourceEnum, {
  UrsPollutionSource,
} from "./UrsPollutionSourceEnum.generated";
import UrsProtectedSpeciesEnum, {
  UrsProtectedSpecies,
} from "./UrsProtectedSpeciesEnum.generated";
import UrsProtectedSpeciesCategoryEnum, {
  UrsProtectedSpeciesCategory,
} from "./UrsProtectedSpeciesCategoryEnum.generated";
import UrsReinforcementLevelEnum, {
  UrsReinforcementLevel,
} from "./UrsReinforcementLevelEnum.generated";
import UrsSpecialFeatureEnum, {
  UrsSpecialFeature,
} from "./UrsSpecialFeatureEnum.generated";
import UrsSpeciesFrequencyEnum, {
  UrsSpeciesFrequency,
} from "./UrsSpeciesFrequencyEnum.generated";
import UrsSurveyBankEnum, {
  UrsSurveyBank,
} from "./UrsSurveyBankEnum.generated";
import UrsSurveyStartEnum, {
  UrsSurveyStart,
} from "./UrsSurveyStartEnum.generated";
import UrsSurveyTypeEnum, {
  UrsSurveyType,
} from "./UrsSurveyTypeEnum.generated";
import UrsTreeDistributionEnum, {
  UrsTreeDistribution,
} from "./UrsTreeDistributionEnum.generated";
import UrsTreeFeatureEnum, {
  UrsTreeFeature,
} from "./UrsTreeFeatureEnum.generated";
import UrsVegetationEnum, {
  UrsVegetation,
} from "./UrsVegetationEnum.generated";
import UrsWaterClarityEnum, {
  UrsWaterClarity,
} from "./UrsWaterClarityEnum.generated";
import WrtFlowLevelEnum, { WrtFlowLevel } from "./WrtFlowLevelEnum.generated";
import WrtFlowImpedanceEnum, {
  WrtFlowImpedance,
} from "./WrtFlowImpedanceEnum.generated";
import WrtFordsAmmoniaEnum, {
  WrtFordsAmmonia,
} from "./WrtFordsAmmoniaEnum.generated";
import WrtFordsLandCoverStageEnum, {
  WrtFordsLandCoverStage,
} from "./WrtFordsLandCoverStageEnum.generated";
import WrtFordsLandUseEnum, {
  WrtFordsLandUse,
} from "./WrtFordsLandUseEnum.generated";
import WrtFordsLivestockEnum, {
  WrtFordsLivestock,
} from "./WrtFordsLivestockEnum.generated";
import WrtFordsNitrateEnum, {
  WrtFordsNitrate,
} from "./WrtFordsNitrateEnum.generated";
import WrtFordsPhosphateEnum, {
  WrtFordsPhosphate,
} from "./WrtFordsPhosphateEnum.generated";
import WrtLandUseEnum, { WrtLandUse } from "./WrtLandUseEnum.generated";
import WrtRainfallEnum, { WrtRainfall } from "./WrtRainfallEnum.generated";
import WrtUpstreamThinkingCatchmentEnum, {
  WrtUpstreamThinkingCatchment,
} from "./WrtUpstreamThinkingCatchmentEnum.generated";
import WrtWestcountryCsiBankVegetationEnum, {
  WrtWestcountryCsiBankVegetation,
} from "./WrtWestcountryCsiBankVegetationEnum.generated";
import WrtWestcountryCsiChannelSubstrateEnum, {
  WrtWestcountryCsiChannelSubstrate,
} from "./WrtWestcountryCsiChannelSubstrateEnum.generated";
import WrtWestcountryCsiInvasivePlantEnum, {
  WrtWestcountryCsiInvasivePlant,
} from "./WrtWestcountryCsiInvasivePlantEnum.generated";
import WrtWestcountryCsiLandUseEnum, {
  WrtWestcountryCsiLandUse,
} from "./WrtWestcountryCsiLandUseEnum.generated";
import WrtWestcountryCsiLegacyPollutionSourceEnum, {
  WrtWestcountryCsiLegacyPollutionSource,
} from "./WrtWestcountryCsiLegacyPollutionSourceEnum.generated";
import WrtWestcountryCsiOutfallEnum, {
  WrtWestcountryCsiOutfall,
} from "./WrtWestcountryCsiOutfallEnum.generated";
import WrtWestcountryCsiPollutionEvidenceEnum, {
  WrtWestcountryCsiPollutionEvidence,
} from "./WrtWestcountryCsiPollutionEvidenceEnum.generated";
import WrtWestcountryCsiPollutionSourceEnum, {
  WrtWestcountryCsiPollutionSource,
} from "./WrtWestcountryCsiPollutionSourceEnum.generated";
import WrtWestcountryCsiWaterBodyTypeEnum, {
  WrtWestcountryCsiWaterBodyType,
} from "./WrtWestcountryCsiWaterBodyTypeEnum.generated";
import WrtWestcountryCsiWaterLevelEnum, {
  WrtWestcountryCsiWaterLevel,
} from "./WrtWestcountryCsiWaterLevelEnum.generated";
import WrtWestcountryCsiWildlifeEnum, {
  WrtWestcountryCsiWildlife,
} from "./WrtWestcountryCsiWildlifeEnum.generated";
import YesNoEnum, { YesNo } from "./YesNoEnum.generated";
import YesNoUnknownEnum, { YesNoUnknown } from "./YesNoUnknownEnum.generated";

export type {
  CesAbundance,
  CesAquaticInvasivePlant,
  CesAquaticVegetationForm,
  CesBankFeature,
  CesBankHorizontalProfile,
  CesBankTerrestrialVegetation,
  CesBankTopMaterial,
  CesBankTopTerrestrialVegetation,
  CesBankTopTreeFeature,
  CesBankTopVegetationManagement,
  CesBankTopVegetationStructure,
  CesBankTreeFeature,
  CesBankVerticalProfile,
  CesCondition,
  CesContinuity,
  CesDominance,
  CesFringeContinuity,
  CesFringeWidth,
  CesJettyAlignment,
  CesJettySize,
  CesLandCoverCategory,
  CesLandCoverType,
  CesNaturalMaterial,
  CesPathWidth,
  CesReinforcementExtent,
  CesReinforcementMaterial,
  CesSurveyedFrom,
  CesTerrestrialInvasivePlant,
  CesTypicalHedgeWidth,
  CesWaterFeatureCondition,
  CesWoodySpeciesCount,
  EcostatusAbsentMinorMajor,
  EcostatusConditionAndUse,
  EcostatusConfidenceLevel,
  EcostatusConnectivity,
  EcostatusHygiene,
  EcostatusLitter,
  EcostatusLitterDisposal,
  EcostatusNfmCategory,
  EcostatusNfmPosition,
  EcostatusNoneOneMore,
  EcostatusNoneSomeMany,
  EcostatusPersonalSafety,
  EcostatusPollutionType,
  EcostatusPoorModerateGood,
  EcostatusRailAccess,
  EcostatusRecreationalFacility,
  EcostatusStudyAreaAccessProvision,
  EcostatusStudyAreaAccessRestriction,
  EcostatusStudyAreaBank,
  EcostatusStudyAreaOwnership,
  ExtendedRiverflySpecies,
  MrsArtificialGroundCover,
  MrsAtpe,
  MrsBankProfile,
  MrsBedMaterialParticleSize,
  MrsChannelCoverage,
  MrsMorphEstuariesDaysToSpringTide,
  MrsMorphEstuariesVisibility,
  MrsMorphEstuariesFloodWallDimension,
  MrsMorphEstuariesSmallFragmentDistribution,
  MrsMorphEstuariesMarginType,
  MrsMorphEstuariesDrainageNetworkType,
  MrsMorphEstuariesCreekType,
  MrsMorphEstuariesSaltMarshLocation,
  MrsMorphEstuariesFragmentation,
  MrsMorphEstuariesFrontBackCreekMargin,
  MrsMorphEstuariesGrazing,
  MrsMorphEstuariesVegetatedIntertidalSedimentSize,
  MrsMorphEstuariesSubtidalSedimentSize,
  MrsMorphEstuariesTidalFloodBarrier,
  MrsFlowType,
  MrsMajorIntermediateMinor,
  MrsReinforcementType,
  MrsReinforcementVerticalExtent,
  MrsRtaAverageBedMaterial,
  MrsRtaCoarsestBedMaterial,
  MrsRtaConditionClass,
  MrsRtaLevelOfConfinement,
  MrsRtaRiverCategory,
  MrsRtaRiverType,
  MrsSedimentSize,
  MrsMudSpotterRainfallIntensity,
  MrsMudSpotterSourceType,
  MrsMudSpotterSourceSubType,
  MrsMudSpotterSourceSize,
  MrsMudSpotterFlow,
  MrsMudSpotterSediment,
  MrsTreeType,
  NeChalkRiversFeature,
  NeChalkRiversModificationType,
  NeChalkRiversPh,
  NeChalkRiversTreeShading,
  NeLakeNaturalnessBirdSpecies,
  NeLakeNaturalnessChemicalAssessmentForm,
  NeLakeNaturalnessEmergentFringe,
  NeLakeNaturalnessFishSpecies,
  NeLakeNaturalnessHerpetofaunaSpecies,
  NeLakeNaturalnessHigherPlantSpecies,
  NeLakeNaturalnessInvertebrateSpecies,
  NeLakeNaturalnessMammalSpecies,
  NeLakeNaturalnessOutflowStructure,
  NeLakeNaturalnessPerimeterTrees,
  NeLakeNaturalnessPlantFunctionalGroup,
  NeLakeNaturalnessRiparianZone,
  NeLakeNaturalnessShorelineModification,
  NeLakeRestorationPrioritiesBiologicalMeasure,
  NeLakeRestorationPrioritiesChemicalMeasure,
  NeLakeRestorationPrioritiesHydrologicalMeasure,
  NeLakeRestorationPrioritiesPhysicalMeasure,
  NeNameSource,
  NeNaturalnessClass,
  NeNaturalnessConfidenceClass,
  NeRestorationRelevance,
  NeRiverNaturalnessBiologicalAssessmentForm,
  NeRiverNaturalnessBirdSpecies,
  NeRiverNaturalnessBryophyteSpecies,
  NeRiverNaturalnessChemicalAssessmentForm,
  NeRiverNaturalnessFeature,
  NeRiverNaturalnessFernSpecies,
  NeRiverNaturalnessFishSpecies,
  NeRiverNaturalnessHerpetofaunaSpecies,
  NeRiverNaturalnessHigherPlantSpecies,
  NeRiverNaturalnessHydrologicalAssessmentForm,
  NeRiverNaturalnessInvertebrateSpecies,
  NeRiverNaturalnessMammalSpecies,
  NeRiverNaturalnessPhysicalAssessmentForm,
  NeRiverRestorationPrioritiesBiologicalMeasure,
  NeRiverRestorationPrioritiesChemicalMeasure,
  NeRiverRestorationPrioritiesHydrologicalMeasure,
  NeRiverRestorationPrioritiesPhysicalMeasure,
  NeYesNoUncertain,
  NwcSeedbankCollection,
  NwcSeedbankPermission,
  NwcSeedbankSpecies,
  NwcSeedbankArea,
  NwcSeedbankLandUse,
  NwcSeedbankVegetation,
  NwcSeedbankSoilType,
  NwcSeedbankProblemPlantSpecies,
  NwcSeedbankEvidenceOfPollution,
  RiverflySpecies,
  StdActivityType,
  StdInvasiveSpecies,
  StdInvasiveSpeciesAmount,
  StdInvasiveSpeciesTreatment,
  StormPhosphatesLevel,
  StormPhosphatesLevelTrend,
  Thames21BadgedGroupEventActivity,
  Thames21BadgedGroupEventLargeRubbish,
  Thames21BadgedGroupEventSetting,
  Thames21ChannelSide,
  Thames21Foreshore,
  Thames21InnsAccessibleBy,
  Thames21InnsSpecies,
  Thames21InnsGrowthStage,
  Thames21InnsCoverage,
  Thames21InnsProximity,
  Thames21InnsManagement,
  Thames21LitterCategory,
  Thames21LitterCleanupFocus,
  Thames21LitterItem,
  Thames21LitterMetric,
  Thames21LitterPolystyreneCover,
  Thames21LitterSmallPlasticCount,
  Thames21LitterSurveyType,
  Thames21RapidAppraisalBeachGrade,
  Thames21RapidAppraisalImmobileItem,
  Thames21River,
  Thames21SlowFlowFeatureType,
  Thames21SlowFlowPondType,
  Thames21SlowFlowServiceType,
  Thames21SlowFlowSite,
  Thames21SlowFlowSuitability,
  Thames21SlowFlowSurveyType,
  Thames21SlowFlowVegetationType,
  Thames21VegetationOrigin,
  Thames21VegetationSite,
  Thames21VegetationStructure,
  Thames21VegetationType,
  UrbanRiverflySpecies,
  UrsApe,
  UrsArtificialBankProfile,
  UrsArtificialBankReinforcement,
  UrsArtificialFeature,
  UrsArtificialFeatureCategory,
  UrsBankMaterial,
  UrsBankProtection,
  UrsBankStructure,
  UrsBridgeType,
  UrsChannelDynamicsCategory,
  UrsChannelDynamicsExtent,
  UrsChannelDynamicsFeature,
  UrsChannelFeature,
  UrsChannelSubstrate,
  UrsCountedHabitatFeature,
  UrsCrossProfile,
  UrsEcologicalCategory,
  UrsEcologicalCharacteristic,
  UrsFlowType,
  UrsLandUse,
  UrsManagementFeature,
  UrsMarginalFeature,
  UrsNaturalBankProfile,
  UrsNuisanceSpecies,
  UrsPercentageHabitatFeature,
  UrsPlanform,
  UrsPollutionIndicator,
  UrsPollutionSource,
  UrsProtectedSpecies,
  UrsProtectedSpeciesCategory,
  UrsReinforcementLevel,
  UrsSpecialFeature,
  UrsSpeciesFrequency,
  UrsSurveyBank,
  UrsSurveyStart,
  UrsSurveyType,
  UrsTreeDistribution,
  UrsTreeFeature,
  UrsVegetation,
  UrsWaterClarity,
  WrtFlowLevel,
  WrtFlowImpedance,
  WrtFordsAmmonia,
  WrtFordsLandCoverStage,
  WrtFordsLandUse,
  WrtFordsLivestock,
  WrtFordsNitrate,
  WrtFordsPhosphate,
  WrtLandUse,
  WrtRainfall,
  WrtUpstreamThinkingCatchment,
  WrtWestcountryCsiBankVegetation,
  WrtWestcountryCsiChannelSubstrate,
  WrtWestcountryCsiInvasivePlant,
  WrtWestcountryCsiLandUse,
  WrtWestcountryCsiLegacyPollutionSource,
  WrtWestcountryCsiOutfall,
  WrtWestcountryCsiPollutionEvidence,
  WrtWestcountryCsiPollutionSource,
  WrtWestcountryCsiWaterBodyType,
  WrtWestcountryCsiWaterLevel,
  WrtWestcountryCsiWildlife,
  YesNo,
  YesNoUnknown,
};

export {
  CesAbundanceEnum,
  CesAquaticInvasivePlantEnum,
  CesAquaticVegetationFormEnum,
  CesBankFeatureEnum,
  CesBankHorizontalProfileEnum,
  CesBankTerrestrialVegetationEnum,
  CesBankTopMaterialEnum,
  CesBankTopTerrestrialVegetationEnum,
  CesBankTopTreeFeatureEnum,
  CesBankTopVegetationManagementEnum,
  CesBankTopVegetationStructureEnum,
  CesBankTreeFeatureEnum,
  CesBankVerticalProfileEnum,
  CesConditionEnum,
  CesContinuityEnum,
  CesDominanceEnum,
  CesFringeContinuityEnum,
  CesFringeWidthEnum,
  CesJettyAlignmentEnum,
  CesJettySizeEnum,
  CesLandCoverCategoryEnum,
  CesLandCoverTypeEnum,
  CesNaturalMaterialEnum,
  CesPathWidthEnum,
  CesReinforcementExtentEnum,
  CesReinforcementMaterialEnum,
  CesSurveyedFromEnum,
  CesTerrestrialInvasivePlantEnum,
  CesTypicalHedgeWidthEnum,
  CesWaterFeatureConditionEnum,
  CesWoodySpeciesCountEnum,
  EcostatusAbsentMinorMajorEnum,
  EcostatusConditionAndUseEnum,
  EcostatusConfidenceLevelEnum,
  EcostatusConnectivityEnum,
  EcostatusHygieneEnum,
  EcostatusLitterEnum,
  EcostatusLitterDisposalEnum,
  EcostatusNfmCategoryEnum,
  EcostatusNfmPositionEnum,
  EcostatusNoneOneMoreEnum,
  EcostatusNoneSomeManyEnum,
  EcostatusPersonalSafetyEnum,
  EcostatusPollutionTypeEnum,
  EcostatusPoorModerateGoodEnum,
  EcostatusRailAccessEnum,
  EcostatusRecreationalFacilityEnum,
  EcostatusStudyAreaAccessProvisionEnum,
  EcostatusStudyAreaAccessRestrictionEnum,
  EcostatusStudyAreaBankEnum,
  EcostatusStudyAreaOwnershipEnum,
  ExtendedRiverflySpeciesEnum,
  MrsArtificialGroundCoverEnum,
  MrsAtpeEnum,
  MrsBankProfileEnum,
  MrsBedMaterialParticleSizeEnum,
  MrsChannelCoverageEnum,
  MrsMorphEstuariesDaysToSpringTideEnum,
  MrsMorphEstuariesVisibilityEnum,
  MrsMorphEstuariesFloodWallDimensionEnum,
  MrsMorphEstuariesSmallFragmentDistributionEnum,
  MrsMorphEstuariesMarginTypeEnum,
  MrsMorphEstuariesDrainageNetworkTypeEnum,
  MrsMorphEstuariesCreekTypeEnum,
  MrsMorphEstuariesSaltMarshLocationEnum,
  MrsMorphEstuariesFragmentationEnum,
  MrsMorphEstuariesFrontBackCreekMarginEnum,
  MrsMorphEstuariesGrazingEnum,
  MrsMorphEstuariesVegetatedIntertidalSedimentSizeEnum,
  MrsMorphEstuariesSubtidalSedimentSizeEnum,
  MrsMorphEstuariesTidalFloodBarrierEnum,
  MrsFlowTypeEnum,
  MrsMajorIntermediateMinorEnum,
  MrsReinforcementTypeEnum,
  MrsReinforcementVerticalExtentEnum,
  MrsRtaAverageBedMaterialEnum,
  MrsRtaCoarsestBedMaterialEnum,
  MrsRtaConditionClassEnum,
  MrsRtaLevelOfConfinementEnum,
  MrsRtaRiverCategoryEnum,
  MrsRtaRiverTypeEnum,
  MrsSedimentSizeEnum,
  MrsMudSpotterRainfallIntensityEnum,
  MrsMudSpotterSourceTypeEnum,
  MrsMudSpotterSourceSubTypeEnum,
  MrsMudSpotterSourceSizeEnum,
  MrsMudSpotterFlowEnum,
  MrsMudSpotterSedimentEnum,
  MrsTreeTypeEnum,
  NeChalkRiversFeatureEnum,
  NeChalkRiversModificationTypeEnum,
  NeChalkRiversPhEnum,
  NeChalkRiversTreeShadingEnum,
  NeLakeNaturalnessBirdSpeciesEnum,
  NeLakeNaturalnessChemicalAssessmentFormEnum,
  NeLakeNaturalnessEmergentFringeEnum,
  NeLakeNaturalnessFishSpeciesEnum,
  NeLakeNaturalnessHerpetofaunaSpeciesEnum,
  NeLakeNaturalnessHigherPlantSpeciesEnum,
  NeLakeNaturalnessInvertebrateSpeciesEnum,
  NeLakeNaturalnessMammalSpeciesEnum,
  NeLakeNaturalnessOutflowStructureEnum,
  NeLakeNaturalnessPerimeterTreesEnum,
  NeLakeNaturalnessPlantFunctionalGroupEnum,
  NeLakeNaturalnessRiparianZoneEnum,
  NeLakeNaturalnessShorelineModificationEnum,
  NeLakeRestorationPrioritiesBiologicalMeasureEnum,
  NeLakeRestorationPrioritiesChemicalMeasureEnum,
  NeLakeRestorationPrioritiesHydrologicalMeasureEnum,
  NeLakeRestorationPrioritiesPhysicalMeasureEnum,
  NeNameSourceEnum,
  NeNaturalnessClassEnum,
  NeNaturalnessConfidenceClassEnum,
  NeRestorationRelevanceEnum,
  NeRiverNaturalnessBiologicalAssessmentFormEnum,
  NeRiverNaturalnessBirdSpeciesEnum,
  NeRiverNaturalnessBryophyteSpeciesEnum,
  NeRiverNaturalnessChemicalAssessmentFormEnum,
  NeRiverNaturalnessFeatureEnum,
  NeRiverNaturalnessFernSpeciesEnum,
  NeRiverNaturalnessFishSpeciesEnum,
  NeRiverNaturalnessHerpetofaunaSpeciesEnum,
  NeRiverNaturalnessHigherPlantSpeciesEnum,
  NeRiverNaturalnessHydrologicalAssessmentFormEnum,
  NeRiverNaturalnessInvertebrateSpeciesEnum,
  NeRiverNaturalnessMammalSpeciesEnum,
  NeRiverNaturalnessPhysicalAssessmentFormEnum,
  NeRiverRestorationPrioritiesBiologicalMeasureEnum,
  NeRiverRestorationPrioritiesChemicalMeasureEnum,
  NeRiverRestorationPrioritiesHydrologicalMeasureEnum,
  NeRiverRestorationPrioritiesPhysicalMeasureEnum,
  NeYesNoUncertainEnum,
  NwcSeedbankCollectionEnum,
  NwcSeedbankPermissionEnum,
  NwcSeedbankSpeciesEnum,
  NwcSeedbankAreaEnum,
  NwcSeedbankLandUseEnum,
  NwcSeedbankVegetationEnum,
  NwcSeedbankSoilTypeEnum,
  NwcSeedbankProblemPlantSpeciesEnum,
  NwcSeedbankEvidenceOfPollutionEnum,
  RiverflySpeciesEnum,
  StdActivityTypeEnum,
  StdInvasiveSpeciesEnum,
  StdInvasiveSpeciesAmountEnum,
  StdInvasiveSpeciesTreatmentEnum,
  StormPhosphatesLevelEnum,
  StormPhosphatesLevelTrendEnum,
  Thames21BadgedGroupEventActivityEnum,
  Thames21BadgedGroupEventLargeRubbishEnum,
  Thames21BadgedGroupEventSettingEnum,
  Thames21ChannelSideEnum,
  Thames21ForeshoreEnum,
  Thames21InnsAccessibleByEnum,
  Thames21InnsSpeciesEnum,
  Thames21InnsGrowthStageEnum,
  Thames21InnsCoverageEnum,
  Thames21InnsProximityEnum,
  Thames21InnsManagementEnum,
  Thames21LitterCategoryEnum,
  Thames21LitterCleanupFocusEnum,
  Thames21LitterItemEnum,
  Thames21LitterMetricEnum,
  Thames21LitterPolystyreneCoverEnum,
  Thames21LitterSmallPlasticCountEnum,
  Thames21LitterSurveyTypeEnum,
  Thames21RapidAppraisalBeachGradeEnum,
  Thames21RapidAppraisalImmobileItemEnum,
  Thames21RiverEnum,
  Thames21SlowFlowFeatureTypeEnum,
  Thames21SlowFlowPondTypeEnum,
  Thames21SlowFlowServiceTypeEnum,
  Thames21SlowFlowSiteEnum,
  Thames21SlowFlowSuitabilityEnum,
  Thames21SlowFlowSurveyTypeEnum,
  Thames21SlowFlowVegetationTypeEnum,
  Thames21VegetationOriginEnum,
  Thames21VegetationSiteEnum,
  Thames21VegetationStructureEnum,
  Thames21VegetationTypeEnum,
  UrbanRiverflySpeciesEnum,
  UrsApeEnum,
  UrsArtificialBankProfileEnum,
  UrsArtificialBankReinforcementEnum,
  UrsArtificialFeatureEnum,
  UrsArtificialFeatureCategoryEnum,
  UrsBankMaterialEnum,
  UrsBankProtectionEnum,
  UrsBankStructureEnum,
  UrsBridgeTypeEnum,
  UrsChannelDynamicsCategoryEnum,
  UrsChannelDynamicsExtentEnum,
  UrsChannelDynamicsFeatureEnum,
  UrsChannelFeatureEnum,
  UrsChannelSubstrateEnum,
  UrsCountedHabitatFeatureEnum,
  UrsCrossProfileEnum,
  UrsEcologicalCategoryEnum,
  UrsEcologicalCharacteristicEnum,
  UrsFlowTypeEnum,
  UrsLandUseEnum,
  UrsManagementFeatureEnum,
  UrsMarginalFeatureEnum,
  UrsNaturalBankProfileEnum,
  UrsNuisanceSpeciesEnum,
  UrsPercentageHabitatFeatureEnum,
  UrsPlanformEnum,
  UrsPollutionIndicatorEnum,
  UrsPollutionSourceEnum,
  UrsProtectedSpeciesEnum,
  UrsProtectedSpeciesCategoryEnum,
  UrsReinforcementLevelEnum,
  UrsSpecialFeatureEnum,
  UrsSpeciesFrequencyEnum,
  UrsSurveyBankEnum,
  UrsSurveyStartEnum,
  UrsSurveyTypeEnum,
  UrsTreeDistributionEnum,
  UrsTreeFeatureEnum,
  UrsVegetationEnum,
  UrsWaterClarityEnum,
  WrtFlowLevelEnum,
  WrtFlowImpedanceEnum,
  WrtFordsAmmoniaEnum,
  WrtFordsLandCoverStageEnum,
  WrtFordsLandUseEnum,
  WrtFordsLivestockEnum,
  WrtFordsNitrateEnum,
  WrtFordsPhosphateEnum,
  WrtLandUseEnum,
  WrtRainfallEnum,
  WrtUpstreamThinkingCatchmentEnum,
  WrtWestcountryCsiBankVegetationEnum,
  WrtWestcountryCsiChannelSubstrateEnum,
  WrtWestcountryCsiInvasivePlantEnum,
  WrtWestcountryCsiLandUseEnum,
  WrtWestcountryCsiLegacyPollutionSourceEnum,
  WrtWestcountryCsiOutfallEnum,
  WrtWestcountryCsiPollutionEvidenceEnum,
  WrtWestcountryCsiPollutionSourceEnum,
  WrtWestcountryCsiWaterBodyTypeEnum,
  WrtWestcountryCsiWaterLevelEnum,
  WrtWestcountryCsiWildlifeEnum,
  YesNoEnum,
  YesNoUnknownEnum,
};
